import React, { useEffect } from 'react'
import { SearchBarProps } from './types'
import { SearchBarContainer, SearchBarInput, SearchButton, SearchButtonContainer } from './styles';

const SearchBar: React.FC<SearchBarProps> = ({
    onSearch,
    placeholder = 'Busca un recurso',
    width = '80%',
}) => {
    const [query, setQuery] = React.useState('');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    const handleSearch = () => {
        onSearch(query);
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    // Se ejecuta cada vez que query cambia
    useEffect(() => {
        if (query.length > 0){
            if (query.length === 0) return;
            onSearch(query);
        }
    }, [query, onSearch]);

    return (
        <SearchBarContainer width={width}>
            <SearchBarInput
                type='text'
                value={query}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress} // Manejo de la tecla "Enter"
                placeholder={placeholder}
            />
            {query.length > 0 && (
                <SearchButtonContainer onClick={handleSearch}>
                    <SearchButton />
                </SearchButtonContainer>
            )}
        </SearchBarContainer>
    )
};

export default SearchBar
